import React from "react";
import styled from "styled-components";
function GridItem({ children, ...props }) {
  return <Item {...props}>{children}</Item>;
}
const Item = styled.li``;
export default GridItem;
